import { inject, Injectable, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeResourceUrl, SafeScript, SafeStyle, SafeUrl } from '@angular/platform-browser';

/**
 * Pipe for bypassing Angular's security sanitization.
 *
 * Use with caution - only for trusted content. Bypasses XSS protection
 * for HTML, styles, scripts, URLs, and resource URLs.
 *
 * @example
 * ```html
 * <div [innerHTML]="trustedHtml | safe:'html'"></div>
 * <iframe [src]="trustedUrl | safe:'resourceUrl'"></iframe>
 * ```
 */
@Pipe({
  name: 'safe',
  standalone: true,
})
@Injectable({
  providedIn: 'root',
})
export class SafePipe implements PipeTransform {
  protected sanitizer = inject(DomSanitizer);

  transform(value: string, type: 'html'|'style'|'script'|'url'|'resourceUrl'): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
    switch (type) {
      case 'html':
        return this.sanitizer.bypassSecurityTrustHtml(value);
      case 'style':
        return this.sanitizer.bypassSecurityTrustStyle(value);
      case 'script':
        return this.sanitizer.bypassSecurityTrustScript(value);
      case 'url':
        return this.sanitizer.bypassSecurityTrustUrl(value);
      case 'resourceUrl':
        return this.sanitizer.bypassSecurityTrustResourceUrl(value);
      default:
        throw new Error(`Invalid safe type specified: ${type}`);
    }
  }
}
